import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useWidgetConfig } from '../WidgetProvider';
import { FormUpdater } from './FormUpdater';
import { SwapFormKey } from './types';
import { URLSearchParamsBuilder } from './URLSearchParamsBuilder';
export const formDefaultValues = {
    [SwapFormKey.FromAmount]: '',
    [SwapFormKey.ToAddress]: '',
    [SwapFormKey.TokenSearchFilter]: '',
};
export const SwapFormProvider = ({ children, }) => {
    const { fromChain, fromToken, fromAmount, toChain, toToken, toAddress, buildSwapUrl, } = useWidgetConfig();
    const defaultValues = useMemo(() => (Object.assign(Object.assign({}, formDefaultValues), { fromChain,
        fromToken, fromAmount: (typeof fromAmount === 'number'
            ? fromAmount === null || fromAmount === void 0 ? void 0 : fromAmount.toPrecision()
            : fromAmount) || formDefaultValues.fromAmount, toChain,
        toToken,
        toAddress })), [fromAmount, fromChain, fromToken, toAddress, toChain, toToken]);
    const methods = useForm({
        // TODO: revisit after RHF release values support
        // values,
        defaultValues,
    });
    return (_jsxs(FormProvider, Object.assign({}, methods, { children: [_jsx(FormUpdater, { defaultValues: defaultValues }), buildSwapUrl ? _jsx(URLSearchParamsBuilder, {}) : null, children] })));
};
